/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

const defaultState = {
  loading: false,
  viewPatientsBuList: [],
  selectedViewPatientBuList: [],
  totalBuPatientsCount: 0,
  allPatientReportGenInQueue: false,
  reportGenerationType: "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_VIEW_PATIENTS_BU_PENDING": {
      return {
        ...state,
        selectedViewPatientBuList: [],
        viewPatientsBuList: [],
      };
    }
    case "GET_VIEW_PATIENTS_BU_FULLFILLED": {
      return {
        ...state,
        selectedViewPatientBuList: [],
        viewPatientsBuList: action.payload.allBuPatients,
        totalBuPatientsCount: action.payload.totalBuPatientsCount,
      };
    }
    case "GET_VIEW_PATIENTS_BU_REJECTED": {
      return {
        ...state,
        selectedViewPatientBuList: [],
        viewPatientsBuList: [],
      };
    }
    // case "GET_VIEW_PATIENTS_BU": {
    //   return {
    //     ...state,
    //     selectedViewPatientList: [],
    //     viewPatientslist: action.payload,
    //   };
    // }
    case "SAVE_VIEW_PATIENTS_BU": {
      return {
        ...state,
        viewPatientsBuList: action.payload?.newBuPatientsAfterDelete.data,
        totalBuPatientsCount:
          state.totalBuPatientsCount - action.payload?.noOfPatientsToDelete,
      };
    }
    case "SELECTED_VIEW_PATIENT_BU_LIST_DATA": {
      return {
        ...state,
        selectedViewPatientBuList: action.payload,
        loading: false,
        // errors: {},
      };
    }
    case "UPDATE_BU_PATIENT_SELECTED_FULLFILLED": {
      return {
        ...state,
        viewPatientsBuList: action.payload.allBuPatients,
        selectedViewPatientBuList: action.payload.allBuPatients,
        loading: false,
        allPatientReportGenInQueue: true,
        reportGenerationType: action.payload.reportGenerationType,
      };
    }

    case "SLICE_PATIENT": {
      const slicedPatient = state.selectedViewPatientBuList.slice(
        action.payload.sliceStart,
        action.payload.sliceEnd
      );

      return {
        ...state,
        selectedViewPatientBuList: slicedPatient,
      };
    }

    default:
      return state;
  }
  return state;
};
